import { CordovaPlugins } from '../../shared/CordovaPlugins';
import { showPermissionDeniedMessage, showErrorMessage } from '../../shared/utils/notifications';

export const scan_barcode = () =>
    new Promise((resolve) => {
        CordovaPlugins().barcodeScanner.scan(
            (result) => {
                const { cancelled, text } = result;

                if (cancelled) {
                    resolve(null);
                    return;
                }

                resolve(text);
            },
            (error = {}) => {
                const err_msg = typeof error === 'string' ? error : error.message || '';

                // Android, iOS, and Windows all have different permisison denied errors, but they all contain the word 'access'
                const is_permission_error = err_msg.toLowerCase().includes('access');

                if (is_permission_error) {
                    showPermissionDeniedMessage(_t('mobile_common_camera'));
                } else {
                    showErrorMessage();
                    $f.mobile.logging.log_error('Barcode scanner failed', { error });
                }

                resolve(null);
            },
            true
        );
    });
